import { useContext } from 'preact/hooks';

import { CountryCodeSelectorContext } from '@/context/CountryCodeSelectorContext';

export default function SearchInput() {
  const { setSearch, inputRef } = useContext(CountryCodeSelectorContext);

  return (
    <input
      ref={inputRef}
      type='text'
      className='w-full rounded-md border px-3 py-2 text-sm'
      placeholder='Search country'
      onInput={(e) => setSearch(e.currentTarget.value)}
    />
  );
}
